/*eslint react-hooks/exhaustive-deps: "off"*/
import React, {useCallback, useEffect, useState} from "react";
import MapBase from "./MapBase";
import WidgetClsCode from "./widgets/WidgetClsCode";
import WidgetVisibleRadius from "./widgets/WidgetVisibleRadius";
import {MapPropsProvider} from "./MapPropsContext";
import useMapProps from "./useMapProps";
import WidgetTableClicked from "./widgets/WidgetTableClicked";
import {formatUid, getApiUrl, makeTableSorterFn, positionToDegress} from "../../utils";
import WidgetContainer from "./widgets/WidgetContainer";
import {WELL_KNOWN_POSITION} from ".././../Constants";
import WidgetLegend from "./widgets/WidgetLegend";
import WidgetVworldCityTypeForCenter from "./widgets/WidgetVworldCityTypeForCenter";
import WidgetPublicGeocoding from "./widgets/WidgetPublicGeocoding";
import Seperator from "./widgets/Seperator";
import WidgetTableForSecureZone from "./widgets/WidgetTableForSecureZone";
import WidgetUidWithShortcut from "./widgets/WidgetUidWithShortcut";
import WidgetToolbar from "./widgets/WidgetToolbar";
import {message} from "antd";
import WidgetSearchByUid from "./widgets/WidgetSearchByUid";
import useVworldCityType from "./useVworldCityType";


const INITIAL_VIEW_STATE = {
  ...WELL_KNOWN_POSITION.남산공원,
  zoom: 16,
};


const ICON_MAPPING = {
//  '21': ['고정국', '고정국'],
//  '32': ['기지국', '기지국'],
//  '85': ['이동중계국', '이동중계국'],
//  '92': ['아마추어국', '아마추어국'],
//  '81': ['전파응용1', '전파응용1'],
//  '82': ['전파응용1', '전파응용1'],
/* 활성화된 국종 */
    '11': ['전파응용1','전파응용1'],
    '12': ['전파응용1','전파응용1'],
    '13': ['전파응용1','전파응용1'],
    '15': ['전파응용1','전파응용1'],
    '16': ['전파응용1','전파응용1'],
    '17': ['전파응용1','전파응용1'],
    '18': ['전파응용1','전파응용1'],
    '19': ['전파응용1','전파응용1'],
    '21': ['전파응용1','전파응용1'],
    '22': ['전파응용1','전파응용1'],
    '23': ['전파응용1','전파응용1'],
    '24': ['전파응용1','전파응용1'],
    '25': ['전파응용1','전파응용1'],
    '27': ['전파응용1','전파응용1'],
    '28': ['전파응용1','전파응용1'],
    '29': ['전파응용1','전파응용1'],
    '30': ['전파응용1','전파응용1'],
    '31': ['전파응용1','전파응용1'],
    '32': ['전파응용1','전파응용1'],
    '33': ['전파응용1','전파응용1'],
    '34': ['전파응용1','전파응용1'],
    '35': ['전파응용1','전파응용1'],
    '36': ['전파응용1','전파응용1'],
    '37': ['전파응용1','전파응용1'],
    '38': ['전파응용1','전파응용1'],
    '40': ['전파응용1','전파응용1'],
    '41': ['전파응용1','전파응용1'],
    '42': ['전파응용1','전파응용1'],
    '43': ['전파응용1','전파응용1'],
    '44': ['전파응용1','전파응용1'],
    '45': ['전파응용1','전파응용1'],
    '46': ['전파응용1','전파응용1'],
    '47': ['전파응용1','전파응용1'],
    '48': ['전파응용1','전파응용1'],
    '49': ['전파응용1','전파응용1'],
    '50': ['전파응용1','전파응용1'],
    '51': ['전파응용1','전파응용1'],
    '52': ['전파응용1','전파응용1'],
    '53': ['전파응용1','전파응용1'],
    '54': ['전파응용1','전파응용1'],
    '55': ['전파응용1','전파응용1'],
    '56': ['전파응용1','전파응용1'],
    '57': ['전파응용1','전파응용1'],
    '58': ['전파응용1','전파응용1'],
    '59': ['전파응용1','전파응용1'],
    '61': ['전파응용1','전파응용1'],
    '62': ['전파응용1','전파응용1'],
    '63': ['전파응용1','전파응용1'],
    '64': ['전파응용1','전파응용1'],
    '65': ['전파응용1','전파응용1'],
    '66': ['전파응용1','전파응용1'],
    '67': ['전파응용1','전파응용1'],
    '68': ['전파응용1','전파응용1'],
    '69': ['전파응용1','전파응용1'],
    '70': ['전파응용1','전파응용1'],
    '71': ['전파응용1','전파응용1'],
    '72': ['전파응용1','전파응용1'],
    '73': ['전파응용1','전파응용1'],
    '74': ['전파응용1','전파응용1'],
    '75': ['전파응용1','전파응용1'],
    '76': ['전파응용1','전파응용1'],
    '77': ['전파응용1','전파응용1'],
    '78': ['전파응용1','전파응용1'],
    '79': ['전파응용1','전파응용1'],
    '80': ['전파응용1','전파응용1'],
    '81': ['전파응용1','전파응용1'],
    '82': ['전파응용1','전파응용1'],
    '83': ['전파응용1','전파응용1'],
    '84': ['전파응용1','전파응용1'],
    '85': ['전파응용1','전파응용1'],
    '86': ['전파응용1','전파응용1'],
    '87': ['전파응용1','전파응용1'],
    '88': ['전파응용1','전파응용1'],
    '89': ['전파응용1','전파응용1'],
    '90': ['전파응용1','전파응용1'],
    '91': ['전파응용1','전파응용1'],
    '92': ['전파응용1','전파응용1'],
    '93': ['전파응용1','전파응용1'],
    '94': ['전파응용1','전파응용1'],
    '95': ['전파응용1','전파응용1'],
    '96': ['전파응용1','전파응용1'],
    '97': ['전파응용1','전파응용1'],
    '98': ['전파응용1','전파응용1'],
    '99': ['전파응용1','전파응용1'],
    'RD': ['전파응용1','전파응용1'],
    'TV': ['전파응용1','전파응용1'],
};


const ICON_CODE_BY_CLS_CODE = Object.entries(ICON_MAPPING).reduce((acc, [clsCode, [iconCode]]) => {
  acc[clsCode] = iconCode;
  return acc;
}, {});


const CLS_CODE_OPTIONS = Object.entries(ICON_MAPPING).map(([clsCode, [iconCode, iconLabel]]) => {
  return { cls_code: clsCode, label: iconLabel };
});

message.config({
  top: 250,
  duration: 15,
  maxCount: 1,
});

const infoByZoom = () => {
  message.info({
    content: <span style={{fontSize:15}}> 해당 zoom에서는 검색이 불가합니다. 확대해 주시기 바랍니다.</span>,
  });
};

const MapPublicStation = () => {
  const mapProps = useMapProps({
    INITIAL_VISIBLE_RADIUS: 500,
    INITIAL_VIEW_STATE,
    INITIAL_POINT_LAYER_PROPS: {
      getIconCode: ({ cls_code, rad_cls_cd }) => {
        try {
          return ICON_MAPPING[(cls_code || rad_cls_cd)][0]
        }catch (e) {
          console.error("not found iconCode for", cls_code, rad_cls_cd);
          return null;
        }
      },
      getIconWidth: (feature, zoom) => {
        let iconWidth = 30;
        if(zoom <= 12 ){
          iconWidth -= iconWidth * (15 - Math.max(7, zoom)) / 11;
          return Math.min(25.2, iconWidth);
        } else if( zoom <= 13) {
          iconWidth -= iconWidth * (15 - Math.max(7, zoom)) / 5;
          return Math.min(25.2, iconWidth);
        } else if (zoom <= 14){
          iconWidth -= iconWidth * (15 - Math.max(7, zoom)) / 3;
          return Math.min(25.2, iconWidth);
        } else if ( zoom === 15) {
          iconWidth -= iconWidth * (16 - Math.max(7, zoom)) / 4;
          return Math.min(30, iconWidth);
        } else if ( zoom >= 16 ){
          return 30;
        }
      }
    },
    // INITIAL_GEOJSON_POLYGON_LAYER_PROPS: {
    //   getFillColor: (feature) => {
    //     return [0, 0, 255];
    //   },
    // },
    INITIAL_LAYER_WMS_TYPES: [
    ],
    INITIAL_WIDGET_STATE: {
      cls_code_list: Object.keys(ICON_MAPPING),
      visible_radius: 500,
      search_uid : '',
    },
  });

  const {
    clickedPointIconObjects,
    widgetState,
    setPointsLayerFilterFunc,
    setVisibleRadius,
    setClickedPointIconObjects,
    viewState,
    setNullForMapViewType, setSearchByUidForMapViewType,
    setIsClusteringPoint,
    setFilteredPointsResponseList,
  } = mapProps;

  const {latitude, longitude, zoom} = viewState;

  const [countedClsNames, setCountedClsNames] = useState();

  useEffect(() => {
    if( zoom < 13) {
      infoByZoom();
    } else if( zoom >= 13) {
      message.destroy();
    }
    // zoom이 15이하일 때는 클러스터링 보기, 초과부터 아이콘 보기
    if(zoom <= 15){
      setIsClusteringPoint(true);
    } else if(zoom > 15){
      setIsClusteringPoint(false);
    }
  }, [zoom]);

  useEffect(() => {
    const {cls_code_list, visible_radius, search_uid} = widgetState;
    // console.log('cls_code of widgetState: ', cls_code);
    // console.log('search_uid of widgetState: ',search_uid);
    if(search_uid) {
      setPointsLayerFilterFunc(() => ({ uid, cls_code }) => {
        if( cls_code_list.includes(cls_code) && uid === search_uid) return true;
      });
    } else {
      setPointsLayerFilterFunc(() => ({ cls_code }) => cls_code_list.includes(cls_code));
    }
    setVisibleRadius(visible_radius);
  }, [widgetState]);

  const onClickedPointInWidgetTable = useCallback((feature) => {
    const { latitude, longitude, lat, lon } = feature;
    const newLongitude = positionToDegress(longitude);
    const newLatitude = positionToDegress(latitude);
    const newFeature = {...feature, position: [newLongitude, newLatitude]};
    setClickedPointIconObjects([newFeature]);
  }, [setClickedPointIconObjects]);

  useEffect(() => {
    // eslint-disable-next-line array-callback-return
    const clsNames = clickedPointIconObjects.map(({cls_code}) => {
     if(cls_code === '21') return '고정국';
     if(cls_code === '32') return '기지국';
     if(cls_code === '85') return '이동중계국';
     if(cls_code === '92') return '아마추어국';
//     if(cls_code === '81') return '전파응용1';
//     if(cls_code === '82') return '전파응용1';
//     if(cls_code === '83') return '전파응용1';
    });

    const countedClsNames = clsNames.reduce((allName, name) => {
      if( name in allName){
        allName[name]++;
      } else {
        allName[name] = 1;
      }
      return allName;
    }, {});
    setCountedClsNames(countedClsNames);
  }, [clickedPointIconObjects]);

  return (
    <MapPropsProvider value={mapProps}>
      <MapBase>
        <WidgetContainer
          onChange={tabTitle => {
            if ( tabTitle === '허가번호 검색' ) {
              setSearchByUidForMapViewType();
              setClickedPointIconObjects([]);
              setVisibleRadius(0);
            }
            else {
              const {visible_radius} = widgetState;
              setVisibleRadius(visible_radius);
              setClickedPointIconObjects([]);
              setFilteredPointsResponseList([]);
              setNullForMapViewType();
            }
          }}
        >
          <div title={"허가번호 검색"}>
            <WidgetPublicGeocoding fetchUrl={getApiUrl({type: "type3"})}/>

            <WidgetVisibleRadius />
          </div>
        </WidgetContainer>

        <WidgetTableClicked
          fetchUrl={getApiUrl({ type: "type2" })}
          clsInfo={countedClsNames}
          getTitle={objects => `${objects.length}개의 무선국`}
          objects={clickedPointIconObjects}
          getRow={({ uid, address, cls_name, rds_svc_form_nm }) =>
            <div>
              <table>
                <tbody>
                <tr>
                  <th>허가번호</th>
                  <td>{formatUid(uid)}</td>
                </tr>
                <tr>
                  <th>국종</th>
                  <td>{cls_name}</td>
                </tr>
                <tr>
                  <th>설(상)치장소</th>
                  <td>{address}</td>
                </tr>
                <tr>
                  <th>용도</th>
                  <td>{rds_svc_form_nm}</td>
                </tr>
                </tbody>
              </table>
            </div>
          }
        />

        <WidgetTableForSecureZone
          fetchUrl={getApiUrl({ type: "type1" })}
          getTitle={(layer) => `${layer.length}개의 무선국`}
          columns={[
            { title: '순번', dataIndex: 'index', key: 'index', width: 80, fixed: 'left', align: 'center', sorter: makeTableSorterFn('index') },
            { title: '허가번호', dataIndex: 'uid', key: 'uid', width: 200, fixed: 'left',
              render: (uid, feature) => WidgetUidWithShortcut({ feature, onClick: onClickedPointInWidgetTable })
               , sorter: makeTableSorterFn('uid')},
            { title: '무선국종', dataIndex: 'cls_name', key: 'cls_name', sorter: makeTableSorterFn('cls_name')},
            { title: '설(상)치장소', dataIndex: 'address', key: 'address', sorter: makeTableSorterFn('address')},
            { title: '용도', dataIndex: 'rds_svc_form_nm', key: 'rds_svc_form_nm', width: 400
              , sorter: makeTableSorterFn('rds_svc_form_nm')},
            { title: '위도', dataIndex: 'latitude', key: 'latitude', width: 140 },
            { title: '경도', dataIndex: 'longitude', key: 'longitude', width: 140 },
          ]}
        />

        <WidgetVworldCityTypeForCenter />

        <WidgetLegend />

      </MapBase>
      <WidgetToolbar />
    </MapPropsProvider>
  );
};


export default MapPublicStation;
